import InventoryIcon from './InventoryIcon';

export default InventoryIcon;
